'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/date/daysAgo.js